import { api } from "@/main/api/base";
import { IHierarchyLevelApi } from "@/main/api/base/hierarchyLevelApi";
import { Result } from "@/main/models/common/resultResponse";
import { UpdateHierarchyLevelRequest } from "@/main/models/request/hierarchyLevel";
import { AxiosResponse } from "axios";

const baseRoute: string = "HierarchyLevel";

export class HierarchyLevelApi extends IHierarchyLevelApi {
	update(request: UpdateHierarchyLevelRequest): Promise<AxiosResponse<Result<boolean>>> {
		return api.put(baseRoute, request);
	}
}
